import { LockReset, Password } from "@mui/icons-material";
import service from "services/maintenance/userChangePasswordService";

const isEditing = (formData) => {
    return !!formData?.id;
};

const userChangePasswordResource = {
    title: "Change Password",
    singular: "Change Password",
    displayField: "Change Password",
    pageIcon: LockReset,
    freeForm: true,

    service: service,

    columns: [
        {
            field: "username",
            header: "User Name"
        }
    ],

    fields: [
        {
            name: "username",
            label: "User Name",
            type: "text",
            required: true,
            unique: true,
            disabledResolver: isEditing
        },
        {
            name: "currentPassword",
            label: "Current Password",
            type: "password",
            // disabled: true
            required: true,
            showRequirements: false
        },
        {
            name: "newPassword",
            label: "Pew Password",
            type: "password",
            // disabled: true
            required: true
        }
    ],
    searchFields: ["name"]
};

export default userChangePasswordResource;
